async function addMiniCartPriceAttributes() {
    const config = {
        selectorCard: ".corner-cowi-cart-item",
        selectorOriginPrice: null,
        selectorFinalLinePrice: ".corner-cowi-cart-item-price",
        selectorSubtotalPrice: "#corner-cowi-cart-cta-total-price-amount",
    };
    if (!config) return;

    const { AjaxCartApi } = BSS_B2B.utils;
    let lineItems = [];

    try {
        const res = await AjaxCartApi.getCart();
        lineItems = res.items;
        if (!lineItems || lineItems.length === 0) return;
    } catch (err) {
        BSS_B2B.logger?.error?.("[BSS B2B] Failed to fetch cart.js:", err);
    }

    const cartItems = document.querySelectorAll(config.selectorCard);

    cartItems.forEach((item) => {
        const href = item.querySelector("a")?.getAttribute("href");
        if (!href || item.hasAttribute("bss-b2b-cart-item-key")) return;

        const originEls = Array.from(item.querySelectorAll(config.selectorOriginPrice));
        const finalEls = Array.from(item.querySelectorAll(config.selectorFinalLinePrice));

        const productMatch = lineItems.find((p) => href.includes(p.variant_id.toString()));
        const itemKey = productMatch?.key;

        if (itemKey && !item.hasAttribute("bss-b2b-cart-item-key")) {
            item.setAttribute("bss-b2b-cart-item-key", itemKey);
        }

        originEls.forEach((el) => {
            if (!el.hasAttribute("bss-b2b-item-original-price")) {
                el.setAttribute("bss-b2b-item-original-price", "");
            }

            const existingQbTable = item.querySelector(".bss-b2b-qb-table");
            if (!existingQbTable) {
                const qbTableDiv = document.createElement("div");
                qbTableDiv.className = "bss-b2b-qb-table";
                el.parentNode?.insertBefore(qbTableDiv, el.nextSibling);
            }
        });

        finalEls.forEach((el) => {
            if (!el.hasAttribute("bss-b2b-final-line-price")) {
                el.setAttribute("bss-b2b-final-line-price", "");
            }
        });
    });

    const subtotalEls = Array.from(document.querySelectorAll(config.selectorSubtotalPrice));

    subtotalEls.forEach((el) => {
        if (!el.hasAttribute("bss-b2b-cart-total-price")) {
            el.setAttribute("bss-b2b-cart-total-price", "");
        }
    });

    BSS_B2B?.observer?.cartSubject?.notifyObserver("CartMutate", "CartPriceMutate");
    BSS_B2B?.observer?.cartSubject?.listenCartCheckout()
}

if(typeof BSS_B2B != undefined) {
  if (window.location.pathname.includes("/cart")) {
    setTimeout(() =>{
      addMiniCartPriceAttributes();
    }, 4000)
  }
  //fix corner app
  function setupMinicart() {
    const miniCart = document.querySelector("#corner-cowi-open-wrapper");
    console.log({miniCart})
    if (!miniCart) return;

    const mainObserver = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            if (mutation.type === "attributes" && mutation.attributeName === "class") {
                addMiniCartPriceAttributes();
            }
        }
    });

    mainObserver.observe(miniCart, {
        attributes: true,
        attributeFilter: ["class"],
    });
  }
  setTimeout(setupMinicart, 3000);
}

